import { useEffect } from "react";
import Lenis from "lenis";

export const lenisRef = { current: null };

export const scrollToId = (id, offset = -64) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenisRef.current) lenisRef.current.scrollTo(el, { offset, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
};

export const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    lenisRef.current = lenis;
    let id;
    const raf = (t) => {
      lenis.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(id);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);
  return null;
};
